<template>
  <v-card outlined class="pa-0 mb-3 grey lighten-5">
    <!-- Tab Tiêu đề phong cách MISA -->
    <div class="misa-tab-header pa-3 d-flex justify-space-between align-center">
      <div class="d-flex align-center">
        <span class="misa-tab-title font-weight-bold primary--text">
          1. Vật tư, hàng hóa cần điều chỉnh
        </span>
      </div>
      <v-btn color="primary" small depressed @click="addRow">
        <v-icon small left>mdi-plus</v-icon> Thêm dòng
      </v-btn>
    </div>

    <div class="table-responsive-wrapper">
      <v-simple-table dense class="misa-grid-table">
        <template v-slot:default>
          <thead>
            <tr class="misa-header-row-1">
              <th rowspan="2" class="text-center" style="width: 35px">#</th>
              <th rowspan="2" style="min-width: 150px">Mã đầu mục</th>
              <th rowspan="2" style="min-width: 220px">Tên đầu mục</th>
              <th rowspan="2" style="min-width: 80px" class="text-center">ĐVT</th>
              <th colspan="3" class="text-center misa-group-qty">
                Số lượng
              </th>
              <th colspan="3" class="text-center misa-group-quality">
                Phẩm chất
              </th>
              <th rowspan="2" style="min-width: 170px" class="text-center">Đề xuất xử lý</th>
              <th rowspan="2" style="width: 35px"></th>
            </tr>
            <tr class="misa-header-row-2">
              <!-- Nhóm Số lượng -->
              <th class="text-center" style="min-width: 100px">Theo sổ sách</th>
              <th class="text-center blue--text text--darken-3 misa-highlight-col" style="min-width: 105px">Theo kiểm kê</th>
              <th class="text-center" style="min-width: 95px">Chênh lệch</th>

              <!-- Nhóm Phẩm chất (3 cột đều có nút ... màu primary) -->
              <th class="text-center green--text text--darken-3 misa-highlight-col" style="min-width: 130px">
                Còn tốt 100%
              </th>
              <th class="text-center orange--text text--darken-3 misa-highlight-col" style="min-width: 130px">
                Kém phẩm chất
              </th>
              <th class="text-center red--text text--darken-3 misa-highlight-col" style="min-width: 130px">
                Mất phẩm chất
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="items.length === 0">
              <td colspan="12" class="text-center grey--text py-5">
                Chưa có mặt hàng nào. Nhấn "+ Thêm dòng" ở trên để thêm.
              </td>
            </tr>
            <tr v-for="(it, idx) in items" :key="idx" class="misa-row">
              <!-- STT -->
              <td class="text-center grey--text">{{ idx + 1 }}</td>

              <!-- 1. Mã đầu mục (Dropdown chọn mã danh mục / đầu mục) -->
              <td class="py-1">
                <v-autocomplete
                  v-model="it.category"
                  :items="categories"
                  :loading="loadingCategories"
                  item-text="code"
                  item-value="id"
                  placeholder="Chọn mã đầu mục..."
                  outlined
                  dense
                  hide-details
                  class="misa-input font-weight-medium"
                  @change="onRowCategoryChange(it)"
                >
                  <template v-slot:item="{ item }">
                    <div class="d-flex justify-space-between align-center w-100">
                      <strong>{{ item.code }}</strong>
                      <span class="grey--text text-caption ml-2">{{ item.name }}</span>
                    </div>
                  </template>
                </v-autocomplete>
              </td>

              <!-- 2. Tên đầu mục -->
              <td class="py-1">
                <v-text-field
                  v-model="it.categoryName"
                  :disabled="!it.category"
                  placeholder="Tên đầu mục..."
                  outlined
                  dense
                  hide-details
                  class="misa-input font-weight-medium"
                  @input="onRowNameInput(it)"
                />
              </td>

              <!-- 3. ĐVT (Dropdown chứa các đơn vị tính của đầu mục) -->
              <td class="py-1">
                <v-select
                  v-model="it.unit"
                  :disabled="!it.category"
                  :items="getUnitsByRow(it)"
                  placeholder="ĐVT"
                  outlined
                  dense
                  hide-details
                  class="misa-input font-weight-medium"
                />
              </td>

              <!-- Theo sổ sách (Disabled) -->
              <td class="py-1">
                <v-text-field
                  v-model.number="it.systemQuantity"
                  type="number"
                  min="0"
                  outlined
                  dense
                  disabled
                  hide-details
                  class="text-right font-weight-medium misa-input misa-disabled-input"
                  @input="onSystemQtyChange(it)"
                />
              </td>

              <!-- 2. Theo kiểm kê (Nhập số lượng thực tế) -->
              <td class="py-1" :class="isQualityMismatch(it) ? 'misa-error-cell' : 'misa-highlight-cell'">
                <v-text-field
                  v-model.number="it.actualQuantity"
                  :disabled="!it.category"
                  type="number"
                  min="0"
                  outlined
                  dense
                  hide-details
                  :class="isQualityMismatch(it) ? 'text-right font-weight-bold red--text text--darken-3 misa-input misa-input-error' : 'text-right font-weight-bold blue--text text--darken-3 misa-input misa-input-active'"
                  @input="onActualQtyChange(it)"
                />
              </td>

              <!-- Chênh lệch (Tự động tính = Theo kiểm kê - Theo sổ sách) -->
              <td class="text-right font-weight-bold py-1 px-2" :class="it.diff < 0 ? 'red--text' : (it.diff > 0 ? 'green--text' : 'grey--text text--darken-2')">
                {{ formatDiff(it.diff) }}
              </td>

              <!-- 1. CỘT CÒN TỐT 100% + NÚT [...] PRIMARY -->
              <td class="py-1" :class="isQualityMismatch(it) ? 'misa-error-cell' : 'misa-highlight-cell'">
                <div class="d-flex align-center">
                  <v-text-field
                    v-model.number="it.qtyGood"
                    :disabled="!it.category"
                    type="number"
                    min="0"
                    placeholder="0,00"
                    outlined
                    dense
                    hide-details
                    class="text-right font-weight-medium green--text text--darken-3 misa-input flex-grow-1"
                    @input="onQualityChange(it)"
                  />
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    :disabled="!it.category"
                    class="ml-1 flex-shrink-0"
                    @click="openSubAssetsDialog(it, idx, 'AVAILABLE')"
                  >
                    <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                  </v-btn>
                </div>
              </td>

              <!-- 2. CỘT KÉM PHẨM CHẤT + NÚT [...] PRIMARY -->
              <td class="py-1" :class="isQualityMismatch(it) ? 'misa-error-cell' : 'misa-highlight-cell'">
                <div class="d-flex align-center">
                  <v-text-field
                    v-model.number="it.qtyDegraded"
                    :disabled="!it.category"
                    type="number"
                    min="0"
                    placeholder="0,00"
                    outlined
                    dense
                    hide-details
                    class="text-right orange--text text--darken-3 misa-input flex-grow-1"
                    @input="onQualityChange(it)"
                  />
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    :disabled="!it.category"
                    class="ml-1 flex-shrink-0"
                    @click="openSubAssetsDialog(it, idx, 'MAINTENANCE')"
                  >
                    <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                  </v-btn>
                </div>
              </td>

              <!-- 3. CỘT MẤT PHẨM CHẤT + NÚT [...] PRIMARY -->
              <td class="py-1" :class="isQualityMismatch(it) ? 'misa-error-cell' : 'misa-highlight-cell'">
                <div class="d-flex align-center">
                  <v-text-field
                    v-model.number="it.qtyBad"
                    :disabled="!it.category"
                    type="number"
                    min="0"
                    placeholder="0,00"
                    outlined
                    dense
                    hide-details
                    class="text-right red--text text--darken-3 misa-input flex-grow-1"
                    @input="onQualityChange(it)"
                  />
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    :disabled="!it.category"
                    class="ml-1 flex-shrink-0"
                    @click="openSubAssetsDialog(it, idx, 'BROKEN')"
                  >
                    <v-icon small>mdi-dots-horizontal-circle-outline</v-icon>
                  </v-btn>
                </div>
              </td>

              <!-- Đề xuất xử lý (Người dùng nhập vào trực tiếp) -->
              <td class="py-1">
                <v-text-field
                  v-model="it.action"
                  :disabled="!it.category"
                  placeholder="Nhập đề xuất xử lý..."
                  outlined
                  dense
                  hide-details
                  class="misa-input font-weight-medium"
                />
              </td>

              <!-- Xóa dòng -->
              <td class="text-center py-1">
                <v-btn icon x-small color="error" @click="removeRow(idx)" title="Xóa dòng này">
                  <v-icon small>mdi-close-circle</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>

          <!-- Hàng chân bảng (Footer tổng cộng) phong cách MISA -->
          <tfoot>
            <tr class="misa-footer-row font-weight-bold">
              <td colspan="4" class="px-3 text-uppercase">
                Tổng cộng
              </td>
              <td class="text-right px-2">{{ formatNumber(totals.systemQty) }}</td>
              <td class="text-right blue--text text--darken-4 px-2">{{ formatNumber(totals.actualQty) }}</td>
              <td class="text-right px-2" :class="totals.diff < 0 ? 'red--text' : (totals.diff > 0 ? 'green--text' : '')">
                {{ formatDiff(totals.diff) }}
              </td>
              <td class="text-right green--text text--darken-3 px-2">{{ formatNumber(totals.goodQty) }}</td>
              <td class="text-right px-2">{{ formatNumber(totals.degradedQty) }}</td>
              <td class="text-right px-2">{{ formatNumber(totals.badQty) }}</td>
              <td colspan="2"></td>
            </tr>
          </tfoot>
        </template>
      </v-simple-table>
    </div>

    <!-- DIALOG CHI TIẾT & THÊM/SỬA SẢN PHẨM KIỂM KÊ (PHÓNG TO) -->
    <v-dialog v-model="subAssetsDialog" max-width="1500px" width="94vw" scrollable>
      <v-card v-if="selectedRow">
        <v-toolbar color="primary" dense dark class="elevation-0 py-1">
          <v-icon left>mdi-format-list-bulleted-square</v-icon>
          <v-toolbar-title class="text-h6 font-weight-bold">
            Chi tiết: {{ selectedRow.categoryCode || selectedRow.assetCode || 'Mã đầu mục' }} - {{ selectedRow.categoryName || selectedRow.assetName || 'Thiết bị' }} - {{ selectedRow.unit || 'Chiếc' }} - {{ getQualityConditionLabel(selectedQualityType) }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="subAssetsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Thông tin tóm tắt: Tổng số lượng cũ & Tổng số lượng mới -->
        <div class="px-5 py-3 grey lighten-4 d-flex justify-space-between align-center flex-wrap">
          <div class="text-body-1 grey--text text--darken-3 font-weight-medium">
            Danh sách thiết bị / sản phẩm chi tiết thuộc danh mục <strong class="primary--text">{{ selectedRow.categoryName || selectedRow.assetName }}</strong>
          </div>
          <div class="d-flex align-center flex-wrap">
            <v-chip color="blue-grey lighten-4" class="font-weight-bold text-subtitle-2 px-3 py-1 mr-3 grey--text text--darken-4">
              <v-icon small left color="grey darken-2">mdi-history</v-icon>
              Tổng số lượng cũ: {{ getInitialCount(selectedRow, selectedQualityType) }} {{ selectedRow.unit || 'sản phẩm' }}
            </v-chip>
            <v-chip color="primary" class="font-weight-bold text-subtitle-2 px-3 py-1 white--text">
              <v-icon small left color="white">mdi-checkbox-marked-circle-outline</v-icon>
              Tổng số lượng mới: {{ getFilteredSubAssets(selectedRow, selectedQualityType).length }} {{ selectedRow.unit || 'sản phẩm' }}
            </v-chip>
          </div>
        </div>

        <v-card-text class="pa-5" style="max-height: 600px; overflow-y: auto;">
          <v-simple-table dense class="elevation-1 sub-assets-table">
            <template v-slot:default>
              <thead>
                <tr class="blue lighten-5">
                  <th class="text-center" style="width: 45px">#</th>
                  <th style="min-width: 200px">Mã sản phẩm</th>
                  <th style="min-width: 240px">Tên sản phẩm</th>
                  <th style="min-width: 180px">Vị trí</th>
                  <th class="text-center" style="min-width: 100px">Mã QR</th>
                  <th class="text-center" style="min-width: 140px">Hình ảnh (tối đa 6)</th>
                  <th class="text-center" style="min-width: 190px">Chuyển TT</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!getFilteredSubAssets(selectedRow, selectedQualityType).length">
                  <td colspan="7" class="text-center py-8 grey--text text-body-1">
                    <v-icon medium color="grey" class="mr-2">mdi-information-outline</v-icon>
                    Không có sản phẩm nào thuộc tình trạng {{ getQualityConditionLabel(selectedQualityType) }} trong hệ thống.
                  </td>
                </tr>
                <tr v-for="(sub, sIdx) in getFilteredSubAssets(selectedRow, selectedQualityType)" :key="sIdx">
                  <!-- STT -->
                  <td class="text-center grey--text font-weight-medium" style="font-size: 14.5px;">{{ sIdx + 1 }}</td>

                  <!-- 1. Mã sản phẩm (Chỉ xem) -->
                  <td class="py-2 font-weight-medium primary--text" style="font-size: 14.5px;">
                    {{ sub.code || '-' }}
                  </td>

                  <!-- 2. Tên sản phẩm (Chỉ xem) -->
                  <td class="py-2 font-weight-medium grey--text text--darken-4" style="font-size: 14.5px;">
                    {{ sub.name || '-' }}
                  </td>

                  <!-- 3. Vị trí (Chỉ xem) -->
                  <td class="py-2 grey--text text--darken-3" style="font-size: 14.5px;">
                    {{ sub.location || '-' }}
                  </td>

                  <!-- 4. Cột Mã QR (nằm bên trái Chuyển TT) -->
                  <td class="text-center py-2">
                    <div class="d-flex align-center justify-center">
                      <img
                        :src="'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + encodeURIComponent(sub.code || sub.id || '')"
                        alt="QR Code"
                        style="width: 48px; height: 48px; object-fit: contain; border: 1px solid #e0e0e0; border-radius: 4px; padding: 2px; background: white;"
                      />
                    </div>
                  </td>

                  <!-- 5. Cột Hình ảnh (Xem thumbnails & nút thêm/sửa ảnh) -->
                  <td class="py-2 text-center" style="min-width: 140px;">
                    <div class="d-flex align-center justify-center flex-wrap">
                      <template v-if="sub.images && sub.images.length">
                        <div class="d-flex align-center mr-1">
                          <v-avatar
                            v-for="(img, imgIdx) in sub.images.slice(0, 3)"
                            :key="imgIdx"
                            size="34"
                            rounded
                            class="mr-1 elevation-1"
                            style="cursor: pointer; border: 1px solid #90caf9;"
                            @click="openImageManager(sub)"
                          >
                            <v-img :src="getImageUrl(img)" />
                          </v-avatar>
                          <v-chip
                            v-if="sub.images.length > 3"
                            x-small
                            color="primary"
                            class="font-weight-bold"
                            style="cursor: pointer;"
                            @click="openImageManager(sub)"
                          >
                            +{{ sub.images.length - 3 }}
                          </v-chip>
                        </div>
                        <v-btn icon x-small color="primary" @click="openImageManager(sub)" title="Quản lý ảnh">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <template v-else>
                        <v-btn
                          x-small
                          outlined
                          color="primary"
                          class="font-weight-medium text-none"
                          @click="openImageManager(sub)"
                        >
                          <v-icon x-small left>mdi-camera-plus</v-icon> Thêm ảnh (0/6)
                        </v-btn>
                      </template>
                    </div>
                  </td>

                  <!-- 6. Chuyển TT (Dropdown trực tiếp 3 trạng thái) -->
                  <td class="py-2 px-2" style="min-width: 190px;">
                    <v-select
                      v-model="sub.status"
                      :items="assetStatusOptions"
                      outlined
                      dense
                      hide-details
                      class="misa-select font-weight-medium"
                      @change="setSubAssetStatus(sub, sub.status)"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider />
        <v-card-actions class="pa-4 grey lighten-5">
          <v-spacer />
          <v-btn color="primary" depressed large class="font-weight-bold px-6 mr-2" @click="saveSubAssetsAndClose">
            <v-icon left>mdi-check</v-icon> Lưu & Cập nhật số lượng
          </v-btn>
          <v-btn text large class="px-5 font-weight-medium" @click="subAssetsDialog = false">
            Đóng
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG QUẢN LÝ & UPLOAD ẢNH CHO TỪNG SẢN PHẨM (TỐI ĐA 6 ẢNH) -->
    <v-dialog v-model="imageManagerDialog" max-width="700px" scrollable>
      <v-card v-if="currentSubAsset">
        <v-toolbar color="primary" dense dark class="elevation-0">
          <v-icon left>mdi-image-multiple</v-icon>
          <v-toolbar-title class="text-subtitle-1 font-weight-bold">
            Ảnh sản phẩm: {{ currentSubAsset.code }} - {{ currentSubAsset.name }} ({{ (currentSubAsset.images || []).length }}/6)
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="imageManagerDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-5">
          <!-- PHẦN 1: KHU VỰC TẢI ẢNH LÊN (BÊN TRÊN) -->
          <div class="mb-5 pa-4 grey lighten-5 rounded border">
            <div class="d-flex justify-space-between align-center mb-3">
              <div class="font-weight-bold text-subtitle-2 grey--text text--darken-3 d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-cloud-upload</v-icon>
                TẢI ẢNH TỪ THIẾT BỊ
              </div>
              <v-chip small :color="(currentSubAsset.images || []).length >= 6 ? 'error' : 'primary'" outlined class="font-weight-bold">
                Đã tải {{ (currentSubAsset.images || []).length }}/6 ảnh
              </v-chip>
            </div>

            <!-- Ô Tải ảnh lên theo chuẩn image-input -->
            <div class="d-flex align-center">
              <div
                v-if="(currentSubAsset.images || []).length < 6"
                class="image-input mr-4 flex-shrink-0"
                @click="chooseImage"
              >
                <span class="placeholder">
                  <v-icon color="primary" class="mb-1" size="32">mdi-camera-plus</v-icon>
                  <span style="font-size: 13px; font-weight: 600; color: #1565c0;">Tải ảnh lên</span>
                </span>
                <input
                  class="file-input"
                  ref="fileInput"
                  type="file"
                  multiple
                  accept="image/png, image/jpeg, image/bmp"
                  @input="onChange"
                />
              </div>
              <div v-else class="grey--text text-caption font-italic mr-4">
                <v-icon color="warning" small class="mr-1">mdi-alert-circle</v-icon>
                Đã đạt giới hạn tối đa 6 ảnh cho sản phẩm này. Hãy xóa bớt ảnh bên dưới nếu muốn tải thêm ảnh mới.
              </div>
              <div class="grey--text text-caption" v-if="(currentSubAsset.images || []).length < 6">
                <div class="mb-1">• Hỗ trợ định dạng: <strong>PNG, JPG, JPEG, BMP</strong></div>
                <div class="mb-1">• Cho phép chọn <strong>nhiều ảnh</strong> cùng lúc</div>
                <div>• Tối đa <strong>6 ảnh</strong> cho mỗi sản phẩm</div>
              </div>
            </div>
          </div>

          <v-divider class="mb-4" />

          <!-- PHẦN 2: DANH SÁCH CÁC ẢNH ĐÃ UPLOAD (BÊN DƯỚI) -->
          <div>
            <div class="text-subtitle-2 font-weight-bold primary--text mb-3 d-flex align-center">
              <v-icon color="primary" small class="mr-1">mdi-image-multiple</v-icon>
              DANH SÁCH ẢNH ĐÃ TẢI LÊN ({{ (currentSubAsset.images || []).length }}/6):
            </div>

            <div v-if="!currentSubAsset.images || !currentSubAsset.images.length" class="text-center py-6 grey lighten-5 rounded">
              <v-icon large color="grey lighten-1">mdi-image-off-outline</v-icon>
              <div class="mt-2 text-caption grey--text text--darken-1 font-weight-medium">Chưa có ảnh nào được tải lên cho sản phẩm này.</div>
            </div>

            <div v-else class="d-flex flex-wrap align-start">
              <div
                v-for="(img, imgIdx) in (currentSubAsset.images || [])"
                :key="imgIdx"
                class="image-preview-wrapper mr-3 mb-3 text-center"
              >
                <div
                  class="image-input"
                  :style="{ 'background-image': `url(${getImageUrl(img)})` }"
                  @click="previewImage(getImageUrl(img))"
                >
                  <!-- Nút X ở góc trên bên phải ảnh -->
                  <v-btn
                    icon
                    x-small
                    dark
                    class="red elevation-2 close-btn"
                    @click.stop="removeImage(imgIdx)"
                    title="Xóa ảnh này"
                  >
                    <v-icon x-small>mdi-close</v-icon>
                  </v-btn>
                </div>
                <div class="text-caption grey--text text--darken-2 mt-1 font-weight-medium">Ảnh {{ imgIdx + 1 }}</div>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider />
        <v-card-actions class="pa-3 grey lighten-5">
          <v-spacer />
          <v-btn color="primary" depressed class="px-5 font-weight-bold" @click="imageManagerDialog = false">
            <v-icon left>mdi-check</v-icon> Xong
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog xem phóng to ảnh (Preview Lightbox) -->
    <v-dialog v-model="previewDialog" max-width="800px">
      <v-card v-if="previewImageUrl" class="pa-2">
        <v-img :src="previewImageUrl" max-height="80vh" contain />
        <v-card-actions class="pa-2">
          <v-spacer />
          <v-btn text color="primary" @click="previewDialog = false">Đóng</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AuditFormItems',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    allAssets: {
      type: Array,
      default: () => []
    },
    locations: {
      type: Array,
      default: () => []
    },
    loadingCategories: {
      type: Boolean,
      default: false
    },
    loadingAssets: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      subAssetsDialog: false,
      imageManagerDialog: false,
      previewDialog: false,
      currentSubAsset: null,
      uploadedFiles: [],
      uploadingImage: false,
      previewImageUrl: '',
      selectedRow: null,
      selectedIndex: -1,
      selectedQualityType: 'ALL',
      actionOptions: [
        'Không xử lý',
        'Xuất kho thanh lý',
        'Nhập kho bổ sung',
        'Sửa chữa / Bảo dưỡng',
        'Đề xuất thanh lý',
        'Đề xuất mua mới thay thế',
        'Điều chuyển vị trí'
      ],
      assetStatusOptions: [
        { text: 'Còn tốt 100%', value: 'AVAILABLE' },
        { text: 'Kém phẩm chất', value: 'MAINTENANCE' },
        { text: 'Mất phẩm chất / Hỏng', value: 'BROKEN' }
      ]
    }
  },
  watch: {
    allAssets: {
      immediate: true,
      handler(newAssets) {
        if (Array.isArray(newAssets) && newAssets.length && Array.isArray(this.items)) {
          this.items.forEach(it => {
            if (it.category && (!it.subAssets || it.subAssets.length === 0)) {
              this.onRowCategoryChange(it)
            }
          })
        }
      }
    }
  },
  computed: {
    totals() {
      let systemQty = 0
      let actualQty = 0
      let goodQty = 0
      let degradedQty = 0
      let badQty = 0

      this.items.forEach(it => {
        systemQty += Number(it.systemQuantity) || 0
        actualQty += Number(it.actualQuantity) || 0
        goodQty += Number(it.qtyGood) || 0
        degradedQty += Number(it.qtyDegraded) || 0
        badQty += Number(it.qtyBad) || 0
      })

      const diff = actualQty - systemQty

      return {
        systemQty,
        actualQty,
        diff,
        goodQty,
        degradedQty,
        badQty
      }
    }
  },
  methods: {
    ...mapActions('upload', ['uploadFile']),
    openImageManager(sub) {
      if (!Array.isArray(sub.images)) {
        this.$set(sub, 'images', [])
      }
      this.currentSubAsset = sub
      this.uploadedFiles = []
      this.imageManagerDialog = true
    },
    chooseImage() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click()
      }
    },
    onChange(e) {
      const files = e && e.target ? e.target.files : e
      if (files && files.length) {
        this.handleFileUpload(files)
      }
      if (e && e.target) {
        e.target.value = ''
      }
    },
    async handleFileUpload(files) {
      if (!files || !files.length || !this.currentSubAsset) return
      if (!Array.isArray(this.currentSubAsset.images)) {
        this.$set(this.currentSubAsset, 'images', [])
      }

      const remainingSlots = 6 - this.currentSubAsset.images.length
      if (remainingSlots <= 0) {
        if (this.$alert && this.$alert.warn) this.$alert.warn('Mỗi sản phẩm chỉ được gắn tối đa 6 ảnh!')
        return
      }

      const filesToUpload = Array.from(files).slice(0, remainingSlots)
      this.uploadingImage = true

      try {
        const formData = new FormData()
        filesToUpload.forEach(f => {
          formData.append('files', f)
        })

        const res = await this.uploadFile(formData)
        if (Array.isArray(res)) {
          res.forEach(f => {
            const url = f && (f.url || (typeof f === 'string' ? f : ''))
            if (url && this.currentSubAsset.images.length < 6) {
              this.currentSubAsset.images.push(url)
            }
          })
          if (this.$alert && this.$alert.success) {
            this.$alert.success(`Đã tải lên thành công ${res.length} ảnh!`)
          }
        }
      } catch (e) {
        console.error('Upload error:', e)
        if (this.$alert && this.$alert.error) {
          this.$alert.error('Lỗi khi tải ảnh lên server: ' + (e.message || e))
        }
      } finally {
        this.uploadingImage = false
        this.uploadedFiles = []
      }
    },
    removeImage(idx) {
      if (this.currentSubAsset && Array.isArray(this.currentSubAsset.images)) {
        this.currentSubAsset.images.splice(idx, 1)
      }
    },
    previewImage(url) {
      this.previewImageUrl = url
      this.previewDialog = true
    },
    getImageUrl(img) {
      if (!img) return ''
      const url = typeof img === 'string' ? img : (img.url || '')
      if (!url) return ''
      if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//') || url.startsWith('data:')) {
        return url
      }
      const apiBase = process.env.VUE_APP_API_URL || ''
      return apiBase.replace(/\/$/, '') + '/' + url.replace(/^\//, '')
    },
    formatNumber(val) {
      if (val === null || val === undefined || isNaN(val)) return '0,00'
      return Number(val).toLocaleString('vi-VN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    formatDiff(diff) {
      if (diff === null || diff === undefined || isNaN(diff)) return '0,00'
      const num = Number(diff)
      if (num < 0) {
        return `(${Math.abs(num).toLocaleString('vi-VN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })})`
      }
      return num.toLocaleString('vi-VN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    addRow() {
      this.items.push({
        category: null,
        categoryCode: '',
        categoryName: '',
        assetCode: '',
        assetName: '',
        unit: '',
        price: 0,
        systemQuantity: 0,
        systemAmount: 0,
        actualQuantity: 0,
        actualAmount: 0,
        diff: 0,
        diffSurplusQty: 0,
        diffSurplusAmount: 0,
        diffDeficitQty: 0,
        diffDeficitAmount: 0,
        qtyGood: 0,
        qtyDegraded: 0,
        qtyBad: 0,
        action: 'Không xử lý',
        note: '',
        subAssets: [],
        _initialSubAssets: []
      })
    },
    removeRow(idx) {
      this.items.splice(idx, 1)
    },
    getUnitsByRow(it) {
      const unitSet = new Set()
      if (it.category) {
        const cat = this.categories.find(c => c.id === it.category || c._id === it.category)
        if (cat) {
          if (cat.unit && typeof cat.unit === 'string' && cat.unit.trim()) {
            unitSet.add(cat.unit.trim())
          }
          if (Array.isArray(cat.units)) {
            cat.units.forEach(u => {
              const uName = typeof u === 'string' ? u : (u && (u.name || u.unitName || u.unit))
              if (uName && uName.trim()) unitSet.add(uName.trim())
            })
          }
        }
        if (Array.isArray(this.allAssets)) {
          const matched = this.allAssets.filter(a => {
            const aCatId = a.category && (a.category.id || a.category._id || a.category)
            return String(aCatId) === String(it.category) || (cat && cat._id && String(aCatId) === String(cat._id))
          })
          matched.forEach(a => {
            if (a.unit && typeof a.unit === 'string' && a.unit.trim()) {
              unitSet.add(a.unit.trim())
            }
          })
        }
      }
      if (it.unit && typeof it.unit === 'string' && it.unit.trim()) {
        unitSet.add(it.unit.trim())
      }
      if (unitSet.size === 0) {
        return ['Chiếc', 'Cái', 'Bộ', 'Hộp', 'Thùng', 'Kg', 'Mét', 'Cuộn', 'Gói', 'Bình', 'Cây']
      }
      return Array.from(unitSet)
    },
    onRowCategoryChange(it) {
      const cat = this.categories.find(c => c.id === it.category || c._id === it.category)
      if (cat) {
        it.categoryCode = cat.code || ''
        it.categoryName = cat.name || ''
        it.assetCode = cat.code || ''
        it.assetName = cat.name || ''
        // Tìm các thiết bị thuộc danh mục / đầu mục này trong allAssets
        const matched = this.allAssets.filter(a => {
          const aCatId = a.category && (a.category.id || a.category._id || a.category)
          return String(aCatId) === String(cat.id) || (cat._id && String(aCatId) === String(cat._id))
        })

        // Đơn vị tính: Lấy chính xác theo tên hàng / danh mục hoặc thiết bị trong hệ thống
        let determinedUnit = ''
        if (cat.unit && typeof cat.unit === 'string' && cat.unit.trim()) {
          determinedUnit = cat.unit.trim()
        } else if (Array.isArray(cat.units) && cat.units.length > 0) {
          const firstU = cat.units[0]
          determinedUnit = typeof firstU === 'string' ? firstU : (firstU.name || firstU.unitName || firstU.unit || '')
        }

        if (!determinedUnit && matched.length > 0) {
          const assetWithUnit = matched.find(a => a.unit && String(a.unit).trim())
          if (assetWithUnit) {
            determinedUnit = String(assetWithUnit.unit).trim()
          }
        }

        it.unit = determinedUnit || 'Bộ'

        // Tạo danh sách sản phẩm chi tiết của đầu mục này
        it.subAssets = matched.map(a => ({
          id: a.id || a._id,
          code: a.code || '-',
          name: a.name || '-',
          unit: a.unit || it.unit,
          quantity: 1,
          status: a.status || 'AVAILABLE',
          images: this.getAssetImages(a),
          location: (a.location && (a.location.name || a.location.code || a.location)) || '-'
        }))

        // Phân loại số lượng theo trạng thái ban đầu trong CSDL
        const goodQty = it.subAssets.filter(s => s.status === 'AVAILABLE').length
        const degradedQty = it.subAssets.filter(s => s.status === 'MAINTENANCE' || s.status === 'BORROWED').length
        const badQty = it.subAssets.filter(s => s.status === 'BROKEN').length
        const totalQty = it.subAssets.length

        it.systemQuantity = totalQty
        it.actualQuantity = totalQty
        it.qtyGood = goodQty
        it.qtyDegraded = degradedQty
        it.qtyBad = badQty
        it.diff = 0
        it.diffSurplusQty = 0
        it.diffSurplusAmount = 0
        it.diffDeficitQty = 0
        it.diffDeficitAmount = 0
        it.action = 'Không xử lý'

        // Lưu snapshot gốc từ sổ sách
        this.$set(it, '_initialSubAssets', JSON.parse(JSON.stringify(it.subAssets)))
      }
    },
    onRowNameInput(it) {
      if (it) {
        it.assetName = it.categoryName || ''
      }
    },
    openSubAssetsDialog(it, idx, qualityType = 'ALL') {
      this.selectedRow = it
      this.selectedIndex = idx
      this.selectedQualityType = qualityType

      // Nếu chưa có subAssets thì tự động nạp các asset thuộc đầu mục này
      if (!Array.isArray(it.subAssets) || it.subAssets.length === 0) {
        const loaded = this.getSubAssets(it)
        this.$set(it, 'subAssets', loaded)
      }

      // Đảm bảo có snapshot gốc _initialSubAssets
      if (!it._initialSubAssets || !Array.isArray(it._initialSubAssets) || it._initialSubAssets.length === 0) {
        if (Array.isArray(it.subAssets) && it.subAssets.length > 0) {
          this.$set(it, '_initialSubAssets', JSON.parse(JSON.stringify(it.subAssets)))
        }
      }

      this.subAssetsDialog = true
    },
    getAssetImages(a) {
      if (!a) return []
      if (Array.isArray(a.images)) {
        return a.images.map(img => (typeof img === 'string' ? img : (img && img.url ? img.url : ''))).filter(Boolean)
      }
      if (typeof a.images === 'string' && a.images.trim()) {
        return [a.images.trim()]
      }
      if (a.image) {
        const u = typeof a.image === 'string' ? a.image : (a.image.url || '')
        return u ? [u] : []
      }
      return []
    },
    getInitialSubAssets(row) {
      if (!row) return []
      if (Array.isArray(row._initialSubAssets) && row._initialSubAssets.length > 0) {
        return row._initialSubAssets
      }
      const catId = row.category
      if (catId && Array.isArray(this.allAssets) && this.allAssets.length > 0) {
        const matched = this.allAssets
          .filter(a => {
            const aCatId = a.category && (a.category.id || a.category._id || a.category)
            return String(aCatId) === String(catId)
          })
          .map(a => ({
            id: a.id || a._id,
            code: a.code || '-',
            name: a.name || '-',
            unit: a.unit || row.unit || 'Chiếc',
            quantity: 1,
            status: a.status || 'AVAILABLE',
            images: this.getAssetImages(a),
            location: (a.location && (a.location.name || a.location.code || a.location)) || '-'
          }))
        if (matched.length > 0) {
          this.$set(row, '_initialSubAssets', JSON.parse(JSON.stringify(matched)))
          return matched
        }
      }
      return []
    },
    getInitialCount(row, qualityType) {
      if (!row) return 0
      const initialList = this.getInitialSubAssets(row)
      if (Array.isArray(initialList) && initialList.length > 0) {
        if (!qualityType || qualityType === 'ALL') return initialList.length
        if (qualityType === 'MAINTENANCE') {
          return initialList.filter(s => s.status === 'MAINTENANCE' || s.status === 'BORROWED').length
        }
        return initialList.filter(s => s.status === qualityType).length
      }

      // Fallback nếu danh mục không có danh sách sản phẩm chi tiết trong CSDL
      if (qualityType === 'AVAILABLE') return Number(row.qtyGood) || 0
      if (qualityType === 'MAINTENANCE') return Number(row.qtyDegraded) || 0
      if (qualityType === 'BROKEN') return Number(row.qtyBad) || 0
      return Number(row.systemQuantity != null ? row.systemQuantity : row.actualQuantity) || 0
    },
    getSubAssets(row) {
      if (!row) return []
      if (Array.isArray(row.subAssets) && row.subAssets.length) {
        return row.subAssets
      }
      const catId = row.category
      if (catId && Array.isArray(this.allAssets)) {
        return this.allAssets
          .filter(a => {
            const aCatId = a.category && (a.category.id || a.category._id || a.category)
            return String(aCatId) === String(catId)
          })
          .map(a => ({
            id: a.id || a._id,
            code: a.code || '-',
            name: a.name || '-',
            unit: a.unit || row.unit || 'Chiếc',
            quantity: 1,
            status: a.status || 'AVAILABLE',
            images: this.getAssetImages(a),
            location: (a.location && (a.location.name || a.location.code || a.location)) || '-'
          }))
      }
      return []
    },
    getFilteredSubAssets(row, type) {
      const allSub = (row && Array.isArray(row.subAssets)) ? row.subAssets : this.getSubAssets(row)
      if (!type || type === 'ALL') return allSub
      if (type === 'MAINTENANCE') {
        return allSub.filter(s => s.status === 'MAINTENANCE' || s.status === 'BORROWED')
      }
      return allSub.filter(s => s.status === type)
    },
    addSubAssetRow() {
      if (!this.selectedRow) return
      if (!Array.isArray(this.selectedRow.subAssets)) {
        this.$set(this.selectedRow, 'subAssets', [])
      }

      let defaultStatus = 'AVAILABLE'
      if (this.selectedQualityType === 'BAD') defaultStatus = 'BROKEN'
      if (this.selectedQualityType === 'DEGRADED') defaultStatus = 'MAINTENANCE'

      let defaultLoc = ''
      if (Array.isArray(this.locations) && this.locations.length) {
        defaultLoc = this.locations[0].name || this.locations[0].code || ''
      }

      this.selectedRow.subAssets.push({
        id: null,
        code: '',
        name: this.selectedRow.categoryName || '',
        quantity: 1,
        status: defaultStatus,
        location: defaultLoc
      })

      this.syncRowQuantitiesFromSubAssets(this.selectedRow)
    },
    removeSubAssetRow(sub) {
      if (!this.selectedRow || !Array.isArray(this.selectedRow.subAssets)) return
      const idx = this.selectedRow.subAssets.indexOf(sub)
      if (idx !== -1) {
        this.selectedRow.subAssets.splice(idx, 1)
        this.syncRowQuantitiesFromSubAssets(this.selectedRow)
      }
    },
    getAssetCodeSuggestions() {
      if (!Array.isArray(this.allAssets)) return []
      // Chỉ lấy mã sản phẩm thuộc đúng đầu mục / danh mục hiện tại
      if (this.selectedRow && this.selectedRow.category) {
        const catId = this.selectedRow.category
        const matched = this.allAssets.filter(a => {
          const aCatId = a.category && (a.category.id || a.category._id || a.category)
          return String(aCatId) === String(catId)
        })
        if (matched.length) {
          return matched.map(a => a.code).filter(Boolean)
        }
      }
      return []
    },
    getLocationSuggestions() {
      const locSet = new Set()
      if (Array.isArray(this.locations)) {
        this.locations.forEach(l => {
          if (l.name) locSet.add(l.name)
          if (l.code) locSet.add(l.code)
        })
      }
      if (Array.isArray(this.allAssets)) {
        this.allAssets.forEach(a => {
          if (a.location) {
            const locName = a.location.name || a.location.code || a.location
            if (typeof locName === 'string' && locName.trim()) locSet.add(locName.trim())
          }
        })
      }
      return Array.from(locSet)
    },
    onSubAssetCodeChange(sub) {
      if (!sub || !sub.code) return
      const codeStr = String(sub.code).trim().toLowerCase()
      const found = this.allAssets.find(a => String(a.code).trim().toLowerCase() === codeStr)
      if (found) {
        sub.code = found.code || sub.code
        if (!sub.name || sub.name === this.selectedRow.categoryName) {
          sub.name = found.name || sub.name
        }
        sub.status = found.status || 'AVAILABLE'
        sub.location = (found.location && (found.location.name || found.location.code || found.location)) || sub.location || ''
      }
      this.syncRowQuantitiesFromSubAssets(this.selectedRow)
    },
    syncRowQuantitiesFromSubAssets(row) {
      if (!row || !Array.isArray(row.subAssets)) return
      let good = 0
      let degraded = 0
      let bad = 0

      row.subAssets.forEach(s => {
        if (s.status === 'BROKEN' || s.status === 'BAD') {
          bad += 1
        } else if (s.status === 'MAINTENANCE' || s.status === 'BORROWED' || s.status === 'DEGRADED') {
          degraded += 1
        } else {
          good += 1
        }
      })

      row.qtyGood = good
      row.qtyDegraded = degraded
      row.qtyBad = bad
      row.actualQuantity = good + degraded + bad
      if (row.systemQuantity === undefined || row.systemQuantity === null) {
        row.systemQuantity = row.actualQuantity
      }
      this.calculateRow(row)
    },
    saveSubAssetsAndClose() {
      if (this.selectedRow) {
        this.syncRowQuantitiesFromSubAssets(this.selectedRow)
      }
      this.subAssetsDialog = false
      if (this.$alert && this.$alert.success) {
        this.$alert.success('Đã cập nhật chi tiết sản phẩm và đồng bộ số lượng kiểm kê.')
      }
    },
    setSubAssetStatus(sub, newStatus) {
      if (!sub) return
      sub.status = newStatus
      this.syncRowQuantitiesFromSubAssets(this.selectedRow)
    },
    cycleSubAssetStatus(sub) {
      if (!sub) return
      if (sub.status === 'AVAILABLE') {
        sub.status = 'MAINTENANCE'
      } else if (sub.status === 'MAINTENANCE' || sub.status === 'BORROWED') {
        sub.status = 'BROKEN'
      } else {
        sub.status = 'AVAILABLE'
      }
      this.syncRowQuantitiesFromSubAssets(this.selectedRow)
    },
    getQualityConditionLabel(type) {
      switch (type) {
        case 'AVAILABLE': return 'Còn tốt 100%'
        case 'MAINTENANCE': return 'Kém phẩm chất'
        case 'BROKEN': return 'Mất phẩm chất / Hỏng'
        default: return 'Tất cả'
      }
    },
    getDialogTitle(type) {
      switch (type) {
        case 'AVAILABLE': return 'Chi tiết sản phẩm Còn tốt 100%'
        case 'MAINTENANCE': return 'Chi tiết sản phẩm Kém phẩm chất'
        case 'BROKEN': return 'Chi tiết sản phẩm Mất phẩm chất / Hỏng'
        default: return 'Chi tiết sản phẩm kiểm kê'
      }
    },
    getDialogHeaderColor(type) {
      switch (type) {
        case 'AVAILABLE': return 'green darken-2'
        case 'MAINTENANCE': return 'orange darken-3'
        case 'BROKEN': return 'red darken-2'
        default: return 'primary'
      }
    },
    getDialogHeaderIcon(type) {
      switch (type) {
        case 'AVAILABLE': return 'mdi-check-circle'
        case 'MAINTENANCE': return 'mdi-alert-circle'
        case 'BROKEN': return 'mdi-close-circle'
        default: return 'mdi-format-list-bulleted-square'
      }
    },
    getAssetStatusLabel(status) {
      switch (status) {
        case 'AVAILABLE': return 'Còn tốt 100%'
        case 'MAINTENANCE': return 'Kém phẩm chất'
        case 'BORROWED': return 'Kém phẩm chất'
        case 'BROKEN': return 'Mất phẩm chất / Hỏng'
        default: return status || 'Còn tốt 100%'
      }
    },
    getAssetStatusColor(status) {
      switch (status) {
        case 'AVAILABLE': return 'success'
        case 'BORROWED': return 'primary'
        case 'MAINTENANCE': return 'warning'
        case 'BROKEN': return 'error'
        default: return 'grey'
      }
    },
    onQualityChange(it) {
      const good = Math.max(0, Number(it.qtyGood) || 0)
      const degraded = Math.max(0, Number(it.qtyDegraded) || 0)
      const bad = Math.max(0, Number(it.qtyBad) || 0)
      it.actualQuantity = good + degraded + bad

      // Đồng bộ trạng thái subAssets khi người dùng nhập trực tiếp trên bảng
      if (Array.isArray(it.subAssets) && it.subAssets.length > 0) {
        let assignedGood = 0
        let assignedDegraded = 0
        let assignedBad = 0

        it.subAssets.forEach(sub => {
          if (assignedGood < good) {
            sub.status = 'AVAILABLE'
            assignedGood++
          } else if (assignedDegraded < degraded) {
            sub.status = 'MAINTENANCE'
            assignedDegraded++
          } else if (assignedBad < bad) {
            sub.status = 'BROKEN'
            assignedBad++
          } else {
            sub.status = 'AVAILABLE'
          }
        })
      }

      this.calculateRow(it)
    },
    onActualQtyChange(it) {
      const act = Math.max(0, Number(it.actualQuantity) || 0)
      const deg = Math.max(0, Number(it.qtyDegraded) || 0)
      const bad = Math.max(0, Number(it.qtyBad) || 0)
      if (act >= deg + bad) {
        it.qtyGood = act - deg - bad
      } else {
        it.qtyGood = act
        it.qtyDegraded = 0
        it.qtyBad = 0
      }
      this.onQualityChange(it)
    },
    onSystemQtyChange(it) {
      this.calculateRow(it)
    },
    calculateRow(it) {
      const price = Number(it.price) || 0
      const sys = Number(it.systemQuantity) || 0
      const act = Number(it.actualQuantity) || 0

      it.systemAmount = sys * price
      it.actualAmount = act * price

      const diff = act - sys
      it.diff = diff

      if (diff < 0) {
        it.diffDeficitQty = Math.abs(diff)
        it.diffDeficitAmount = Math.abs(diff) * price
        it.diffSurplusQty = 0
        it.diffSurplusAmount = 0
        if (!it.action || it.action === 'Không xử lý' || it.action === 'Nhập kho bổ sung') {
          it.action = 'Xuất kho thanh lý'
        }
      } else if (diff > 0) {
        it.diffSurplusQty = diff
        it.diffSurplusAmount = diff * price
        it.diffDeficitQty = 0
        it.diffDeficitAmount = 0
        if (!it.action || it.action === 'Không xử lý' || it.action === 'Xuất kho thanh lý') {
          it.action = 'Nhập kho bổ sung'
        }
      } else {
        it.diffSurplusQty = 0
        it.diffSurplusAmount = 0
        it.diffDeficitQty = 0
        it.diffDeficitAmount = 0
      }
    },
    isQualityMismatch(it) {
      if (!it.category && !it.categoryName && !it.categoryCode && !it.assetName && !it.assetCode) return false
      const act = Number(it.actualQuantity) || 0
      const good = Number(it.qtyGood) || 0
      const degraded = Number(it.qtyDegraded) || 0
      const bad = Number(it.qtyBad) || 0
      return act !== (good + degraded + bad)
    },
    validate() {
      if (!Array.isArray(this.items) || this.items.length === 0) {
        if (this.$alert && this.$alert.warn) {
          this.$alert.warn('Vui lòng thêm ít nhất một mặt hàng kiểm kê!')
        }
        return false
      }

      for (let i = 0; i < this.items.length; i++) {
        const it = this.items[i]
        const itemLabel = it.categoryName || it.categoryCode || it.assetName || it.assetCode || `Dòng ${i + 1}`

        if (!it.category && !it.categoryName && !it.categoryCode && !it.assetName && !it.assetCode) {
          if (this.$alert && this.$alert.warn) {
            this.$alert.warn(`Dòng ${i + 1}: Vui lòng chọn mã hoặc tên hàng kiểm kê!`)
          }
          return false
        }

        const act = Number(it.actualQuantity) || 0
        const good = Number(it.qtyGood) || 0
        const degraded = Number(it.qtyDegraded) || 0
        const bad = Number(it.qtyBad) || 0
        const totalQuality = good + degraded + bad

        if (act !== totalQuality) {
          if (this.$alert && this.$alert.error) {
            this.$alert.error(
              `Dòng ${i + 1} (${itemLabel}): Số lượng theo kiểm kê (${act}) không khớp với tổng phẩm chất (${totalQuality} = Còn tốt ${good} + Kém PC ${degraded} + Mất PC ${bad}). Vui lòng kiểm tra lại!`
            )
          }
          return false
        }
      }

      return true
    }
  }
}
</script>

<style scoped>
.misa-tab-header {
  background-color: #e8f0fe;
  border-bottom: 2px solid var(--v-primary-base, #0d47a1);
}
.misa-tab-title {
  color: var(--v-primary-base, #0d47a1) !important;
  font-size: 13px !important;
}
.table-responsive-wrapper {
  width: 100%;
  max-height: 480px;
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
}
.table-responsive-wrapper >>> .v-data-table__wrapper {
  overflow: visible !important;
}
.misa-grid-table {
  border-collapse: separate !important;
  border-spacing: 0;
  font-size: 13px !important;
}
.misa-grid-table th,
.misa-grid-table td {
  border: 1px solid #d0d7de !important;
  font-size: 13px !important;
  line-height: 1.4 !important;
}
.misa-grid-table th {
  font-weight: 600 !important;
  font-size: 13px !important;
}
.misa-header-row-1 th {
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
  background-color: #e3f2fd !important;
  color: #1565c0 !important;
  font-size: 13px !important;
}
.misa-header-row-2 th {
  position: sticky !important;
  top: 32px !important;
  z-index: 10 !important;
  background-color: #e3f2fd !important;
  color: #1565c0 !important;
  font-size: 13px !important;
}
.misa-group-qty {
  background-color: #bbdefb !important;
  border-bottom: 1px solid #90caf9 !important;
}
.misa-group-quality {
  background-color: #c5cae9 !important;
  border-bottom: 1px solid #9fa8da !important;
}
.misa-highlight-col {
  border: 2px solid #ef5350 !important;
}
.misa-highlight-cell {
  background-color: #fff9c4 !important;
}
.misa-error-cell {
  background-color: #ffebee !important;
  border: 1.5px solid #e53935 !important;
}
.misa-input-error >>> input {
  color: #c62828 !important;
  font-weight: bold !important;
}
.misa-footer-row td {
  position: sticky !important;
  bottom: 0 !important;
  z-index: 9 !important;
  background-color: #eceff1 !important;
  box-shadow: 0 -1px 0 #b0bec5, 0 1px 0 #b0bec5;
  font-size: 13px !important;
}
.misa-input >>> .v-input__control {
  min-height: 28px !important;
}
.misa-input >>> .v-input__slot {
  min-height: 28px !important;
  padding: 0 6px !important;
}
.misa-input >>> input,
.misa-input >>> .v-select__selection,
.misa-input >>> .v-select__selection--comma,
.misa-input >>> input::placeholder,
.misa-input >>> .v-input__append-inner {
  font-size: 13px !important;
}
.sub-assets-table {
  border-collapse: separate !important;
  border-spacing: 0;
  font-size: 14.5px !important;
}
.sub-assets-table th,
.sub-assets-table td {
  border: 1px solid #d0d7de !important;
  font-size: 14.5px !important;
  font-family: inherit !important;
  padding: 8px 12px !important;
}
.sub-assets-table th {
  font-weight: 700 !important;
  font-size: 15px !important;
  color: #1565c0 !important;
}
.sub-assets-input >>> .v-input__control {
  min-height: 38px !important;
}
.sub-assets-input >>> .v-input__slot {
  min-height: 38px !important;
  padding: 0 10px !important;
}
.sub-assets-input >>> input,
.sub-assets-input >>> .v-select__selection,
.sub-assets-input >>> .v-select__selection--comma,
.sub-assets-input >>> input::placeholder,
.sub-assets-input >>> .v-input__append-inner {
  font-size: 14.5px !important;
  font-family: inherit !important;
}
.misa-disabled-input >>> input,
.misa-disabled-input >>> .v-select__selection,
.misa-disabled-input >>> .v-select__selection--comma {
  color: rgba(0, 0, 0, 0.87) !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 500 !important;
}
.misa-disabled-input >>> .v-input__slot {
  background-color: #f1f3f4 !important;
}

.image-input {
  display: block;
  width: 140px;
  height: 140px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
  position: relative;
  border-radius: 6px;
  border: 1px dashed #bdbdbd;
  overflow: hidden;
  background-color: #fafafa;
}
.image-preview-wrapper .image-input {
  border: 1px solid #90caf9;
}
.placeholder {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #555;
  font-size: 14px;
  font-family: inherit;
  flex-direction: column;
}
.placeholder:hover {
  background: #e8eaf6;
}
.file-input {
  display: none;
}
.close-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
  width: 22px;
  height: 22px;
}
</style>
